module.exports = {
  container: {
    title: '轻量、开放、安全的Web3基础设施平台',
    content:
      'BitFlow旨在构建稳定、可靠、安全的区块链基础设施，聚合全网主流公链节点，提供便捷的 LSD质押服务，维持数字资产的稳定性和流动性。',
    info: 'Networks：10+ 合作伙伴：20+ 社区用户：20000+',
    button: '立即质押',
  },
  intro: {
    title: 'BitFlow核心功能',
    coinTitle1: '非托管质押',
    coinContent1: '通过去中心化节点，用户资产保存在用户自己的钱包中，BitFlow只保留验证密钥，不会触碰用户的提款密钥。',
    coinTitle2: '流动性质押',
    coinContent2: '提供安全便捷的流动性质押服务、使用多态预言机从各大 DEX 获取流动性，保持价格稳定',
    coinTitle3: 'LSO',
    coinContent3: '质押即挖矿，新型代币融资模式，用户仅需质押代币到平台锁定，即可获得挖矿收益。',
  },
  advantage: {
    title: 'BitFlow亮点',
    title2: '提供安全、高效、可靠的LSD质押服务',
    content:
      'BitFlow通过全球分布式节点基础设施，构建更具协作性、更强大的多链生态系统，作为 Web3、DeFi和加密金融的基础层，允许用户以风险分散、自动管理和高效的方式参与LSD质押服务，通过数字资产连通世界，开创数字生态应用新纪元。',
  },
  more: {
    title: '创新模式 高效便捷',
    content: 'BitFlow使用户能够使用他们质押的代币，访问探索 BitFlow集成的Web3应用和DeFi服务。',
    button: '了解更多',
    boxTitle1: '多链质押',
    boxContent1: '目前合作的公链包括ETH、BNB、Polygon、ARB、SUI 等，未来将支持更多网络。',
    boxTitle2: '去中心化',
    boxContent2: '质押用户和节点运营商自由匹配，创建、提取和奖励委托都由智能合约在执行层处理。',
    boxTitle3: '节点管理',
    boxContent3: '支持用户自己部署验证器进行节点管理，提供云服务支持，节约同步时间。',
    boxTitle4: '区块监控',
    boxContent4: 'BitFlow全天候实时监控所有节点和API服务，并为用户呈现更全面，直观的数据。',
    boxTitle5: '复合收益',
    boxContent5: '释放数字资产流动性，用户可以获得质押、流动性挖矿和邀请返佣多重收益。',
  },
  ecology: {
    title: 'BitFlow生态 质押未来',
    content: '探索Web3应用场景和DeFi服务',
  },
  media: '全球合作伙伴',
  bitFlowIntro: {
    content:
      '全球首创去中心化螺旋永动机制的完美通证经济模型，打造去中心打造去中心化分布式最强web3基础设施平台产永续提款机。',
  },
  transaction: {
    wallet: '钱包登录',
    assets: {
      title: '我的算力',
      content: '我的算力',
      text1: '充币',
      text2: '交易',
      text3: '转账',
      text4: '置换',
      text5: '资产',
    },
    place: {
      tab1: '下单',
      tab2: '复投',
      text1: 'USDT余额',
      text2: 'FLOW余额',
      mask: '你尚未绑定上级钱包，无法下单、是否',
      maskLight: '立即绑定',
      payNeed: '支付所需',
      confirm: '确认下单',
      contact: '联系我们',
      maskInputTitle: '上级地址',
      maskInputContent: '链接有效账户，才能链接成功',
      placeholder: '请输入有效的上级地址',
      confirmLink: '确认链接',
    },
  },
}
